import { render, staticRenderFns } from "./userDetailsModal.vue?vue&type=template&id=911c58e6&scoped=true&"
import script from "./userDetailsModal.vue?vue&type=script&lang=js&"
export * from "./userDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./userDetailsModal.vue?vue&type=style&index=0&id=911c58e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911c58e6",
  null
  
)

export default component.exports